/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_TasksInputs */

const en_nav_tasks = /** @type {(inputs: Nav_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks`)
};

const pt_br2_nav_tasks = /** @type {(inputs: Nav_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividades`)
};

/**
* | output |
* | --- |
* | "Tasks" |
*
* @param {Nav_TasksInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const nav_tasks = /** @type {((inputs?: Nav_TasksInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_TasksInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_tasks(inputs)
	return pt_br2_nav_tasks(inputs)
});